var render = function (_h, _vm) {
  var _c = _vm._c
  return _c("div", { staticClass: "reset-container" }, [
    _c(
      "button",
      { staticClass: "button", on: { click: _vm.listeners["reset-date"] } },
      [_vm._v("Redefinir")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }